import * as Yup from 'yup';
import { v4 as uuidV4 } from 'uuid';
import { IContactInfo } from './contactInfo';
import { IContactInfoFormValues } from './contactInfoFormValues';
import { IContactInfoUpsert } from './contactInfoUpsert';
import ValidationHelper from '../../../../services/helper/validationHelper';

export default class ContactInfoModelHelper {
    public static createFormValues = (contactInfo : IContactInfo | null) : IContactInfoFormValues => {
        if (!contactInfo) return {
            id: 0,
            guid: uuidV4(),
            name: '',
            address: '',
            telNumber: '',
            faxNumber: '',
            email: '',
            isActive: true,
        };

        return {
            id: contactInfo.id,
            guid: contactInfo.guid,
            name: contactInfo.name,
            address: contactInfo.address,
            telNumber: contactInfo.telNumber,
            faxNumber: contactInfo.faxNumber,
            email: contactInfo.email,
            isActive: contactInfo.isActive,
        };
    };

    public static createUpsert = (formValues : IContactInfoFormValues) : IContactInfoUpsert => {
        return {
            id: formValues.id,
            guid: formValues.guid,
            name: formValues.name,
            address: formValues.address,
            telNumber: formValues.telNumber,
            faxNumber: formValues.faxNumber,
            email: formValues.email,
            isActive: formValues.isActive,
        };
    };

    public static formSchema = () : Yup.ObjectSchema<IContactInfoFormValues> => Yup.object().shape({
        id: Yup.number().typeError('Please enter a number.').required('Required'),
        guid: Yup.string().required('Required'),
        name: Yup.string().trim().min(1, 'Must have at least 1 character').required('Required'),
        address: Yup.string().trim().defined().nullable(),
        telNumber: Yup.string().trim().defined().nullable()
            .test('Valid Phone Number', 'Invalid Phone Number', (value) => {
                if (!value) return true;
                return ValidationHelper.isValidPhoneNumber(value);
            }),
        faxNumber: Yup.string().trim().defined().nullable()
            .test('Valid Fax Number', 'Invalid Fax Number', (value) => {
                if (!value) return true;
                return ValidationHelper.isValidPhoneNumber(value);
            }),
        email: Yup.string().email().trim().defined().nullable(),
        isActive: Yup.boolean().required('Required'),
    });
}
